import { defineStore } from 'pinia';
import { menusApi } from '@/common/api';
import router from '@/router';
import request from "@/utils/request";
import md2html from '@/utils/md2html';

/**
 * 获取文档详情
 * @param {*} param0 
 * @returns {Promise<{id:number;group_name:string;title:string;name:string;type:'template'|'component'|'other'; html:string;view_count:number;readme_md:string;titles:{title:string;tag:string}[]}>}
 */
const documentContentApi = ({ project_name, name } = {}) => {
  const password = localStorage.getItem("dev-password")
  return request.get("/client/document/content", { params: { project_name, name, password } }).then(res => ({ ...res, ...md2html(res.readme_md) }))
}
function setRouterQuery(params) {
  const query = Object.assign({}, router.currentRoute.value.query, params)
  console.log(query);
  router.push({ query });
}
/**
 * 根据组件名称判断是否是该分组下的组件
 */
function isChild(name, groups) {
  for (let i = 0; i < groups.length; i++) {
    const { children } = groups[i]
    for (let j = 0; j < children.length; j++) {
      if (children[j].name === name) {
        return true
      }
    }
  }
  return false
}




export const useMenuStore = defineStore('menus-store', {
  state: () => ({
    _loading: false,
    _projects: [{ label: "VUE2", value: "stellar-ui" }, { label: "VUE3", value: "stellar-ui-plus" }],
    _projectName: '',
    _menus: [],
    _groups: [],
    /**
     * 当前激活的菜单
     * @type {string}
     */
    _activeMenu: '',
    /**
     * 激活的组件名
     * @type {string}
     */
    _activeComponent: '',
    /**
     * 当前文档内容
     * @type {string}
     */
    _activeDocument: "",
    /**
     * 文档标题列表
     * @type {Array<{title:string;tag:string}>}
     */
    _titles: [],
    /** 文档类型
      * @type {'template'|'component'|'other'}
      */
    _documentType: ""
  }),
  actions: {
    async initMenus() {
      try {
        let { projectName = 'stellar-ui-plus' } = router.currentRoute.value.query

        this.setProject(projectName)
      } catch (error) { }
    },
    async setProject(projectName) {
      this._loading = true
      try {
        let { menu, active } = router.currentRoute.value.query
        let menus = await menusApi(projectName);
        // 删除没有文档的菜单
        menus.forEach(item => {
          item.children = item.children.filter(child => child.children.length > 0)
        })
        menus = menus.filter(item => item.children.length > 0);
        this._menus = menus;
        // 修正菜单
        if (!menu || !menus.find(item => item.name === menu)) {
          menu = menus[0].name
        }
        this._groups = menus.find(item => item.name === menu).children
        // 修正组件
        if (!active || !isChild(active, this._groups)) {
          active = this._groups[0]?.children[0]?.name
        }
        this._projectName = projectName;

        const res = await documentContentApi({ project_name: this._projectName, name: active })
        this._activeDocument = res.html;
        this._titles = res.titles;
        this._documentType = res.type
        this._activeMenu = menu
        this._activeComponent = active
        setRouterQuery({ projectName, menu, active });
      } catch (error) {
        console.error(error);
      }
      this._loading = false
    },
    async setActiveMenu(menu) {
      this._loading = true
      try {
        const groups = this._menus.find(item => item.name === menu).children || []
        const active = groups[0]?.children[0]?.name
        const res = await documentContentApi({ project_name: this._projectName, name: active })
        this._activeDocument = res.html;
        this._titles = res.titles;
        this._documentType = res.type
        this._activeMenu = menu;
        this._groups = groups
        this._activeComponent = active
        setRouterQuery({ menu, active: this._activeComponent })
      } catch (error) {
        console.error(error);
      }
      this._loading = false
    },
    async setActiveComponent(active) {
      this._loading = true
      try {
        const { html, titles } = await documentContentApi({ project_name: this._projectName, name: active })
        this._activeDocument = html;
        this._titles = titles;
        this._activeComponent = active;
        setRouterQuery({ active })
      } catch (error) {
        console.error(error);
      }
      this._loading = false
    },

    async toSearch(menu, active) {
      this._loading = true
      try {
        const groups = this._menus.find(item => item.name === menu).children || []
        const { html, titles, type } = await documentContentApi({ project_name: this._projectName, name: active })
        this._activeDocument = html;
        this._titles = titles;
        this._documentType = type
        this._activeMenu = menu;
        this._groups = groups
        this._activeComponent = active;
        setRouterQuery({ menu, active })
      } catch (error) {

      }
      this._loading = false
    },

  },
  getters: {
    loading: (state) => state._loading,
    projects: (state) => state._projects,
    projectName: (state) => state._projectName,
    config: (state) => state._config,
    rootStyle: (state) => state._style,
    menus: (state) => state._menus,
    groups: (state) => state._groups,
    activeMenu: (state) => state._activeMenu,
    activeComponent: (state) => state._activeComponent,

    activeDocument: (state) => state._activeDocument,

    titles: (state) => state._titles,

    documentType: (state) => state._documentType
  },
});
